import type { TrainingLessonSpecific } from './trainingLessonUi';

export const elder1MinistrationEn: TrainingLessonSpecific = {
  intro:
    'An elder ministers, blesses with faith and reverence, and coordinates with leaders. The faith of the one who blesses matters—but so does the faith of the one who receives. Ministering is consistency, not one-off events.',
  objectives: [
    'Understand the elder’s role in ministering.',
    'Learn to give blessings with faith and reverence.',
    'Coordinate with leaders.',
    'Develop habits of ongoing dignity.',
    'Create a weekly ministering plan.',
  ],
  briefHeading: 'Ministering in brief',
  briefBody:
    'Blessings, visits, and prayers are offered humbly, under the direction of those who hold keys when applicable. Faithful ministering strengthens wards and families.',
  scriptures: [
    { ref: 'D&C 20:38–45', text: 'Elder duties: preach, teach, baptize, confirm, administer the sacrament.' },
    { ref: 'James 5:14–15', text: '…let them pray over him, anointing him with oil in the name of the Lord…' },
    { ref: 'D&C 42:44', text: 'Elders pray and lay hands on the sick in the Lord’s name.' },
    { ref: 'D&C 107:12', text: 'The office of an elder… is to administer in spiritual things…' },
    { ref: 'Mark 16:18', text: '…they shall lay hands on the sick, and they shall recover.' },
  ],
  didYouKnow: [
    'The faith of the one who blesses matters—but so does the faith of the one who receives.',
    'Ministering is consistency, not isolated events.',
  ],
  practiceItems: [
    'Spiritual preparation before officiating (prayer, dignity)',
    'Ask permission before giving a blessing (to whoever presides or the family)',
    'Use clear, reverent words when blessing',
    'Coordinate with leaders for ministering visits',
    'Follow up after a blessing or visit',
    'Journal one ministering experience this week',
  ],
  reflectionQuestions: [
    'What holds me back from ministering or giving blessings?',
    'How can I coordinate better with leaders and companions?',
    'How can I grow in faith to bless?',
  ],
  actionText: 'One ministering visit with a clear purpose.',
};
